<template>
  <div
    class="max-w-1600 mx-auto w-full relative h-full"
    :class="isDarkMode ? 'text-app-color': 'text-dark-600'"
  >
    <div class="px-20 pt-50 md:px-70 mx-auto min-h-full flex-grow flex flex-col h-full bg-primary">
      <!-- header -->
      <!-- <div class="mb-40 md:flex justify-between items-start relative">
        <div>
          <h1 class="text-24 font-bold leading-none">Task board</h1>
          <div class="mt-4" :class="isDarkMode ? 'text-app-color' : 'text-dark-600'">
            <p v-if="todoTasksLength > 0" class="text-16">
              There
              <span v-if="todoTasksLength > 1">are</span>
              <span v-else>is</span>
              <span class="font-bold ml-5">{{ todoTasksLength }}</span>
              task<span v-if="todoTasksLength !== 1">s</span>
            </p>
            <p v-else class="text-16">There are no tasks</p>
          </div>
        </div>
        <FilterModal :tags="filteredTags" hide-book-title @toggleTag="filterByTag" />
      </div> -->

      <div class="flex items-start">
        <div ref="wrapperRef" class="flex items-start overflow-x-auto pb-150" :class="{'cursor-grab': hasScroll}">
          <draggable
            v-model="computedTaskRows"
            group="rows"
            :delay="300"
            delay-on-touch-only="true"
            ghost-class="my-sortable-ghost-task"
            chosen-class="grab-class-task"
            drag-class="grab-class-task"
            item-key="id"
            filter=".no-drag"
            handle=".drag-handler"
            :force-fallback="true"
            :fallback-class="isDarkMode ? 'force-fallback-dark-task' : 'force-fallback-light-task'"
            class="h-full flex draggable"
            @start="onDragStart"
            @end="onDragEnd"
            @mousedown.stop.prevent
            @mousemove.stop.prevent
          >
            <template #item="{ element }">
              <TaskList
                :key="element.id"
                :item="element"
                :class="[]"
                class="md:min-h-200 h-full min-w-268 w-268 mx-15 first:ml-1 last:mr-1"
                @getTasks="getTasks"
              />
            </template>
          </draggable>

          <NewTaskRow v-if="showNewRow" class="min-w-268 w-268 ml-30 mr-1" :book-id="bookId" @close="close" />
        </div>
        <ButtonModule
          prefix="icon-add text-13"
          :icon-has-margin="false"
          has-hover
          class="rounded-6 anim-all p-7 ml-15 mt-24"
          :class="[
            isMagenta ? 'text-dark-600' : 'text-app-color',
            isDarkMode ? 'hover:bg-dark-500' : 'hover:bg-menu-hover',
          ]"
          @click.stop="addNewRow"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import FilterModal from '@/components/task-board/FilterModal'
import TaskList from '@/components/task-board/TaskList'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import NewTaskRow from '@/components/task-board/NewTaskRow'

import draggable from 'vuedraggable'

import { taskService } from '@/services'

import { defineComponent, computed, onMounted, nextTick, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { TaskList, ButtonModule, NewTaskRow, draggable },

  setup () {
    const { state, getters, commit, dispatch } = useStore()
    const route = useRoute()

    const wrapperRef = ref(null)
    const showNewRow = ref(false)

    const books = computed(() => state.book.books.filter(b => !b.isSection))
    const headquarters = computed(() => state.team.headquarters)
    const settings = computed(() => state.settings.settings)
    const showSidebar = computed(() => state.settings.showSidebar)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isMagenta = computed(() => getters.isMagenta)
    const isTeamAccount = computed(() => getters.isTeamAccount)
    const tasks = computed(() => state.task.tasks)
    const rows = computed(() => state.task.rows)
    const rowsLength = ref(0)
    const hasScroll = ref(false)
    const bookId = computed(() => parseInt(route.params.id))

    const computedTaskRows = computed({
      get: () => {
        return rows.value
          .sort((a, b) => {
            if (a.order > b.order) return 1
            if (a.order < b.order) return -1
            return 0
          })
      },
      set: (value) => {
        value.forEach((item, index) => {
          commit('updateRow', { id: item.id, order: index })
        })

        setTimeout(() => {
          taskService.orderRow({ ids: value.map(item => item.id), bookId: bookId.value })
        }, 100)
      }
    })

    const todoTasksLength = computed(() => tasks.value.length)

    let tagIds = null

    const filteredTags = computed(() => {
      const usedTags = {}

      tasks.value.forEach(t => {
        usedTags[t.bookId] = []
      })

      tasks.value.forEach(t => {
        const ids = new Set(usedTags[t.bookId].map(tag => tag.id))

        usedTags[t.bookId] = [...usedTags[t.bookId], ...t.taskTags.filter(d => !ids.has(d.id))]
      })

      return usedTags
    })

    watch(() => route.params.id, (value) => {
      if (value) {
        dispatch('getRows', { bookId: route.params.id })
        dispatch('getTasks', { tagIds, bookId: route.params.id })
      }
    })

    watch(() => state.task.rows, (value) => {
      setTimeout(() => {
        if (value?.length > rowsLength.value && rowsLength.value !== 0) {
          if (wrapperRef.value) {
            wrapperRef.value.scrollLeft += window.innerWidth
          }
        }
        rowsLength.value = value.length
        checkCursor()
      }, 100)
    }, {
      deep: true
    })

    onMounted(() => {
      nextTick(() => {
        rowsLength.value = rows.value.length

        const allBooks = books.value

        if (isTeamAccount.value) allBooks.push(headquarters.value)

        dispatch('getTaskTags', allBooks.map(b => b.id))
        dispatch('getBook', route.params.id).then(res => {
          if (isTeamAccount.value && res.id && res.chat?.id) {
            dispatch('getMessages', {
              bookId: res.id,
              chatId: res.chat.id
            })
          }
        })
        dispatch('getRows', { tagIds, bookId: route.params.id })
        dispatch('getTasks', { tagIds, bookId: route.params.id })

        dragScroll()
        checkCursor()

        correctWrapperHeight()

        new ResizeObserver(correctWrapperHeight).observe(wrapperRef.value)
      })
    })

    function dragScroll () {
      let isDown = false
      let startX
      let scrollLeft

      wrapperRef.value.addEventListener('mousedown', (e) => {
        if (e.path.some(item => item.className?.includes('prevent-drag-scroll'))) return

        isDown = true
        startX = e.pageX - wrapperRef.value.offsetLeft
        scrollLeft = wrapperRef.value.scrollLeft
      })
      wrapperRef.value.addEventListener('mouseleave', () => {
        isDown = false
      })
      wrapperRef.value.addEventListener('mouseup', () => {
        isDown = false
      })
      wrapperRef.value.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - wrapperRef.value.offsetLeft
        const walk = (x - startX) * 3 // scroll-fast
        wrapperRef.value.scrollLeft = scrollLeft - walk
      })
    }

    function checkCursor () {
      hasScroll.value = wrapperRef.value.scrollWidth > wrapperRef.value.clientWidth
    }

    async function getTasks () {
      commit('toggleBookLoading', true)
      await dispatch('getTasks', { tagIds, bookId: bookId.value })
      commit('toggleBookLoading', false)
    }

    function filterByTag (ids) {
      tagIds = ids
      dispatch('getTasks', {
        bookId: bookId.value,
        tagIds: ids
      }).finally(_ => commit('toggleBookLoading', false))
    }

    function addNewRow () {
      showNewRow.value = true
    }

    function close () {
      showNewRow.value = false
    }

    function onDragStart () {
      document.body.classList.add('grabbing')
    }

    function onDragEnd () {
      document.body.classList.remove('grabbing')
    }

    function correctWrapperHeight () {
      if (wrapperRef.value) {
        wrapperRef.value.style.height = 'auto'

        nextTick(() => {
          const headerHeight = 60 // TODO: move header height to design setting
          const gap = headerHeight + wrapperRef.value.offsetTop
          const rect = wrapperRef.value.getBoundingClientRect()

          if (rect.height < window.innerHeight - gap) {
            wrapperRef.value.style.height = `${window.innerHeight - gap}px`
          } else {
            wrapperRef.value.style.height = 'auto'
          }
        })
      }
    }

    return {
      // ref
      wrapperRef,
      // data
      showNewRow,
      hasScroll,
      // computed
      filteredTags,
      settings,
      rows,
      bookId,
      isMagenta,
      isDarkMode,
      showSidebar,
      todoTasksLength,
      computedTaskRows,
      // functions
      filterByTag,
      getTasks,
      addNewRow,
      close,
      onDragStart,
      onDragEnd
    }
  }
})
</script>
